// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"06996cffead2e569027f","293":"884707b04850a1931255","461":"1e6a1f1abb06cc54f6ef","518":"31d83e69f13f7642c134","779":"0f79ea4516b8d68dd67d"}[chunkId] + ".js";
};